/*

THIS IS JUST AN EXAMPLE SET UP FOR A REDUCER.
WE CAN DO WHATEVER WE WANT IN IT I JUST WANTED TO GIVE A BASE SKELETON - SAMEER

*/

import * as types from '../actions/actionTypes';
import { initShippingAddress, initGuest } from '../helper/Utility'

export const cartReducer = (state = {}, action) => {
  var newState = { ...state }
  switch (action.type) {

    // SETS THE INITIAL CART AFTER FETCHING 
    case types.SET_CART:
      newState = action.payload;
      if (newState.shipping_address === null || newState.customer === null) {
        newState.shipping_address = initShippingAddress();
        newState.customer = initGuest();
      }
      return newState;
      break;
    // UPDATES CART QUANTITY
    case types.UPDATE_LINE_ITEM:
      let lineItemLength = action.payload.length;

      for (let i = 0; i < lineItemLength; i++) {
        const data = action.payload[i];
        state.line_items[i] = data;
      }

      return state;
      break;
    // DELETE CART ITEM
    case types.DELETE_LINE_ITEM:
      // let cartItemLength = action.payload.length;
      const payload = action.payload;

      // const filterState = state.line_items.map(stateItem => {
      //   if (!action.payload.includes(stateItem.product_id)) {

      //     return state.line_items.indexOf(stateItem)
      //   }
      // });
      // const filterReverse = action.payload.filter(x => state.line_items.includes(x));

      // for (let i = 0; i < cartItemLength; i++) {
      //   if (action.payload[i].product_id !== state.line_items[i].product_id) {
      //     removeIndex = i;
      //     return
      //   } else {
      //     removeIndex = cartItemLength - 1;
      //   }
      // }
      state.line_items = payload;
      return state;
      break;
    // UPDATES THE SHIPPING INFORMATION OF CUSTOMER  
    case types.UPDATE_SHIPPING_ADDRESS:
      // newState.shipping_address = {...state.shipping_address};
      let addressFieldsLength = action.payload.length;

      for (let i = 0; i < addressFieldsLength; i++) {
        const data = action.payload[i];
        state.shipping_address[data.fieldToUpdate] = data.value;
      }
      return state;
      break;
    case types.SET_SHIPPING_ADDRESS:
      newState.shipping_address = { ...action.payload };
      return newState;
      break;
    case types.UPDATE_CUSTOMER:
      state.customer = { ...state.customer };
      let customerFieldsLength = action.payload.length;

      for (let i = 0; i < customerFieldsLength; i++) {
        const data = action.payload[i];
        state.customer[data.fieldToUpdate] = data.value;
      }
      return state;
      break;

    case types.UPDATE_DELIVERY_DATE:
      state.delivery = { ...action.payload };
      return state;
      break;
    case types.UPDATE_BILLING_ADDRESS:
      state.billing_address = (state.billing_address !== null) ? { ...state.billing_address } : {};
      let baddressFieldsLength = action.payload.length;

      for (let i = 0; i < baddressFieldsLength; i++) {
        const data = action.payload[i];
        state.billing_address[data.fieldToUpdate] = data.value;
      }
      return state;
      break;
    case types.UPDATE_PAYMENT:
      state.payment = { ...state.payment };
      let PaymentFieldsLength = action.payload.length;

      for (let i = 0; i < PaymentFieldsLength; i++) {
        const data = action.payload[i];
        state.payment[data.fieldToUpdate] = data.value;
      }
      return state;
      break;
    case types.REMOVE_CARD:
      let tokensLength = state.customer.customer_tokens.length;
      var spliceIndex = null;
      for (let i = 0; i < tokensLength; i++) {
        const token = state.customer.customer_tokens[i];
        if (token.credit_card_token === action.payload.credit_card_token) {
          spliceIndex = i;
        }
      }
      state.customer.customer_tokens.splice(spliceIndex, 1);
      return state;
      break;
    default:
      return state;
  }
}
